export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const THIRD_PARTY_LINKS_BASE_URL = import.meta.env
  .VITE_THIRD_PARTY_LINKS_BASE_URL;
export const POST_LOGOUT_REDIRECT_URL = import.meta.env
  .VITE_POST_LOGOUT_REDIRECT_URL;
export const MODE = import.meta.env.MODE;
